// extracted by mini-css-extract-plugin
module.exports = {"fallback":"ErrorFallback_fallback__bGRTv","container":"ErrorFallback_container__jougK","actions":"ErrorFallback_actions__mp_PI"};